<img [galleryPhoto]="lightboxItem.Url" />
<loader></loader>
<span class="error-message">The image could not be loaded.</span>
